import React from 'react';
import { motion } from 'framer-motion';
import { ScissorsIcon, DogIcon, PizzaIcon, SparklesIcon } from 'lucide-react';
export function SocialProof() {
  const logos = [{
    name: 'Barberías',
    icon: ScissorsIcon
  }, {
    name: 'Veterinarias',
    icon: DogIcon
  }, {
    name: 'Restaurantes',
    icon: PizzaIcon
  }, {
    name: 'Estéticas',
    icon: SparklesIcon
  }];
  return <section className="py-10 border-y border-gray-100 bg-gray-50/50" data-id="element-152">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-153">
        <p className="text-center text-sm font-medium text-gray-400 mb-6 uppercase tracking-wider" data-id="element-154">
          Confían en nosotros negocios locales como:
        </p>

        <div className="flex flex-wrap justify-center items-center gap-8 sm:gap-16 opacity-60 grayscale" data-id="element-155">
          {logos.map((logo, index) => {
          const Icon = logo.icon;
          return <motion.div key={logo.name} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-center gap-2 text-gray-500" data-id="element-156">
                <Icon className="w-6 h-6" data-id="element-157" />
                <span className="font-heading font-bold text-lg tracking-tight" data-id="element-158">
                  {logo.name}
                </span>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}